// Ordinal + chain-title helpers shared between backend (steps payload)
// and frontend (StepMenu rendering). ACCS / similar chained surveys
// share a single template id across instances, so the 2nd+ instances
// get a "(2nd complaint)" / "(Queja 2)" suffix so the patient can tell
// them apart.

// English ordinal — "1st", "2nd", "3rd", "11th", "21st".
export const ordinalEn = (n: number): string => {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;

  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
};

export const decorateChainTitle = (
  title: string | null | undefined,
  position: number,
  language: string
): string => {
  const safe = title || '';
  if (language === 'es') return `${safe} (Queja ${position})`;

  return `${safe} (${ordinalEn(position)} complaint)`;
};
